import { HOLDINGS_HIDE_TAB_ON_MOBILE } from 'constants/constants';
import { sortBy, prop, filter, flatten, map, path } from 'helpers/ramda';
import { sortOnCreatedAtDesc } from 'helpers/utils';

export const getFilterData = (selectedContractType, productsList) =>
  productsList.reduce(
    (acc, item) => {
      if (item.contract_type.includes(selectedContractType)) {
        acc.push({
          label: item.symbol,
          id: item.id,
          selectValue: item.symbol,
          sort_priority: item.underlying_asset.sort_priority,
        });
      }
      return acc;
    },
    [
      {
        label: 'All Contracts',
        id: 0,
        selectValue: 'all',
        sort_priority: 1,
      },
    ]
  );

export const sortByPriority = sortBy(prop('sort_priority'));

export const getProductId = (productsList, value) => {
  const product = productsList.find(product => product.symbol === value);
  return product ? product.id : 0;
};

export const filterMobileTabList = list => {
  return list.filter(tab => !HOLDINGS_HIDE_TAB_ON_MOBILE.includes(tab.id));
};

/**
 * @param {*} data
 * @param {*} holdingsType
 * @returns {Object} { data: Array }
 *
 * @description
 * getAllContractsData will iterate over whole holdings object and pull holdings data from each contract type and create a array and put in allContractsData object
 * If `holdingsType` is 'openPositions', and contractType `key` is 'tracker' the it is not included in the allContractsData
 * Returns an object with a data array containing all contract data from the input data object.
 *
 * @example
 * getAllContractsData({ future: { data: [{ id: 1, symbol: 'BTC' }] } }, 'openPositions');
 * // returns { data: [{ id: 1, symbol: 'BTC' }] }
 *
 * getAllContractsData({ future: { data: [{ id: 1, symbol: 'BTC' }] } }, 'openOrders');
 * // returns { data: [{ id: 1, symbol: 'BTC' }] }
 *
 * getAllContractsData({ future: { data: [{ id: 1, symbol: 'BTC' }] } }, 'stopOrders');
 * // returns { data: [{ id: 1, symbol: 'BTC' }] }
 *
 * getAllContractsData({ tracker: { data: [{ id: 1, symbol: 'BTC' }] , future: { data: [{ id: 2, symbol: 'BTC' }] } } }, 'openPosition');
 * // returns { data: [{ id: 2, symbol: 'BTC' }] }
 *
 * getAllContractsData({ tracker: { data: [{ id: 1, symbol: 'BTC' }] , future: { data: [{ id: 2, symbol: 'BTC' }] } } }, 'openOrders');
 * // returns { data: [{ id: 2, symbol: 'BTC' }, { id: 1, symbol: 'BTC' }] }
 */
export const getAllContractsData = (data, holdingsType) => {
  const obj = {};
  obj.data = filter(
    obj => obj,
    flatten(
      map(
        key =>
          key === 'tracker' && holdingsType === 'openPositions'
            ? []
            : path([key, 'data'], data),
        Object.keys(data)
      )
    )
  );
  obj.data.sort(sortOnCreatedAtDesc);
  return obj;
};
